import { VarKey } from './VarKey'
import { VariableDefinitionInterface, VariableScope } from './VariableDefinition.Interface'
import { UserVars } from './Variables.Interfaces'

export const VariableDefenitions: VariableDefinitionInterface[] = [
  {
    id: 'Entity personName',
    varName: 'PERSON_NAME',
    name: 'User - Name',
    shortName: 'Name',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'Entity email',
    varName: 'EMAIL',
    name: 'User - Email',
    shortName: 'Email',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'Entity phonenumber',
    varName: 'PHONENUMBER',
    name: 'User - Phone Number',
    shortName: 'Phone Number',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAddressLine1',
    varName: 'USER_ADDRESS_LINE_1',
    name: 'User - Address Line 1',
    shortName: 'Address Line 1',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAddressLine2',
    varName: 'USER_ADDRESS_LINE_2',
    name: 'User - Address Line 2',
    shortName: 'Address Line 2',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserCity',
    varName: 'USER_CITY',
    name: 'User - City',
    shortName: 'City',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserState',
    varName: 'USER_STATE',
    name: 'User - State',
    shortName: 'State',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserZip',
    varName: 'USER_ZIP',
    name: 'User - Zip',
    shortName: 'Zip',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserLastIntent',
    varName: 'USER_LAST_INTENT',
    name: 'User - Last Intent',
    shortName: 'Last Intent',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserCountryCode',
    varName: 'USER_COUNTRY_CODE',
    name: 'User - Country Code',
    shortName: 'Country Code',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserHasCompletedProfile',
    varName: 'USER_HAS_COMPLETED_PROFILE',
    name: 'User - Has Completed Profile?',
    shortName: 'Has Completed Profile?',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserHasConfirmedProfile',
    varName: 'USER_HAS_CONFIRMED_PROFILE',
    name: 'User - Has Confirmed Profile?',
    shortName: 'Has Confirmed Profile',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_HasShortProfile',
    varName: 'USER_HAS_SHORT_PROFILE',
    name: 'User - Has Short Profile',
    shortName: 'Has Short Profile',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAnsweringMachine',
    varName: 'USER_ANSWERING_MACHINE',
    name: 'User - Answering Machine',
    shortName: 'Answering Machine',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserPersona',
    varName: 'USER_PERSONA',
    name: 'User - Persona',
    shortName: 'Persona',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserHasUnhandled',
    varName: 'USER_HAS_UNHANDLED',
    name: 'User - Has Unhandled',
    shortName: 'Has Unhandled',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAccountType',
    varName: 'USER_ACCOUNT_TYPE',
    name: 'User - Account Type',
    shortName: 'Account Type',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserCRMId',
    varName: 'USER_CRM_ID',
    name: 'User - CRM Id',
    shortName: 'CRM Id',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserCRMStatus',
    varName: 'USER_CRM_STATUS',
    name: 'User - CRM Status',
    shortName: 'CRM Status',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserLastAgentName',
    varName: 'USER_LAST_AGENT_NAME',
    name: 'User - Last Agent Name',
    shortName: 'Last Agent Name',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserLeadhasSentEmailReceipt',
    varName: 'USER_LEADHAS_SENT_EMAIL_RECEIPT',
    name: 'User - Lead Has Sent Email Receipt',
    shortName: 'Lead Has Sent Email Receipt',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserLeadhasSentToFMS',
    varName: 'USER_LEADHAS_SENT_TO_FMS',
    name: 'User - Lead Has Sent To FMS',
    shortName: 'Lead Has Sent To FMS',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserReviewNPSScore',
    varName: 'USER_REVIEW_NPS_SCORE',
    name: 'User - Review NPS Score',
    shortName: 'Review NPS Score',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserReviewNPSFeedback',
    varName: 'USER_REVIEW_NPS_FEEDBACK',
    name: 'User - Review NPS Feedback',
    shortName: 'Review NPS Feedback',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserReviewNPSTopic',
    varName: 'USER_REVIEW_NPS_TOPIC',
    name: 'User - Review NPS Topic',
    shortName: 'Review NPS Topic',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserTemporaryFMSID',
    varName: 'USER_TEMPORARY_FMSID',
    name: 'User - Temporary FMS ID',
    shortName: 'Temporary FMS ID',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserReviewFeedbackPersona',
    varName: 'USER_REVIEW_FEEDBACK_PERSONA',
    name: 'User - Review NPS Persona',
    shortName: 'Review NPS Persona',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenFeatureMenu',
    varName: 'USERHAS_SEEN_FEATURE_MENU',
    name: 'User - hasSeen Feature Menu',
    shortName: 'hasSeen Feature Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenInventoryMenu',
    varName: 'USERHAS_SEEN_INVENTORY_MENU',
    name: 'User - hasSeen Inventory Menu',
    shortName: 'hasSeen Inventory Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenAnythingElseMenu',
    varName: 'USERHAS_SEEN_ANYTHING_ELSE_MENU',
    name: 'User - hasSeen AnythingElse Menu',
    shortName: 'hasSeen AnythingElse Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenCostMenu',
    varName: 'USERHAS_SEEN_COST_MENU',
    name: 'User - hasSeen Cost Menu',
    shortName: 'hasSeen Cost Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenContactMenu',
    varName: 'USERHAS_SEEN_CONTACT_MENU',
    name: 'User - hasSeen Contact Menu',
    shortName: 'hasSeen Contact Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenSizeMenu',
    varName: 'USERHAS_SEEN_SIZE_MENU',
    name: 'User - hasSeen Size Menu',
    shortName: 'hasSeen Size Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenProblemMenu',
    varName: 'USERHAS_SEEN_PROBLEM_MENU',
    name: 'User - hasSeen Problem Menu',
    shortName: 'hasSeen Problem Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenAccountMenu',
    varName: 'USERHAS_SEEN_ACCOUNT_MENU',
    name: 'User - hasSeen Account Menu',
    shortName: 'hasSeen Account Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenChangeAccountMenu',
    varName: 'USERHAS_SEEN_CHANGE_ACCOUNT_MENU',
    name: 'User - hasSeen ChangeAccount Menu',
    shortName: 'hasSeen ChangeAccount Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenAccountLoginMenu',
    varName: 'USERHAS_SEEN_ACCOUNT_LOGIN_MENU',
    name: 'User - hasSeen AccountLogin Menu',
    shortName: 'hasSeen AccountLogin Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenPurchaseProcessMenu',
    varName: 'USERHAS_SEEN_PURCHASE_PROCESS_MENU',
    name: 'User - hasSeen PurchaseProcess Menu',
    shortName: 'hasSeen PurchaseProcess Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenLeaseTermsMenu',
    varName: 'USERHAS_SEEN_LEASE_TERMS_MENU',
    name: 'User - hasSeen LeaseTerms Menu',
    shortName: 'hasSeen LeaseTerms Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenMoveMenu',
    varName: 'USERHAS_SEEN_MOVE_MENU',
    name: 'User - hasSeen Move Menu',
    shortName: 'hasSeen Move Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenGSExistingMenu',
    varName: 'USERHAS_SEEN_GS_EXISTING_MENU',
    name: 'User - hasSeen GSExisting Menu',
    shortName: 'hasSeen GSExisting Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenGSPotentialMenu',
    varName: 'USERHAS_SEEN_GS_POTENTIAL_MENU',
    name: 'User - hasSeen GSPotential Menu',
    shortName: 'hasSeen GSPotential Menu',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserhasSeenSMSDisclaimer',
    varName: 'USERHAS_SEEN_SMS_DISCLAIMER',
    name: 'User - hasSeen SMS Disclaimer',
    shortName: 'hasSeen SMS Disclaimer',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserCronReceiptType',
    varName: 'USER_CRON_RECEIPT_TYPE',
    name: 'User - Cron Receipt Type',
    shortName: 'Cron Receipt Type',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAfterNavigateHolder',
    varName: 'USER_AFTER_NAVIGATE_HOLDER',
    name: 'User - After Navigate Holder',
    shortName: 'After Navigate Holder',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserProfileCollectHolder',
    varName: 'USER_PROFILE_COLLECT_HOLDER',
    name: 'User - Profile Collect Holder',
    shortName: 'Profile Collect Holder',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserPreviousChannelHolder',
    varName: 'USER_PREVIOUS_CHANNEL_HOLDER',
    name: 'User - Previous Channel Holder',
    shortName: 'Previous Channel Holder',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_WantToSearchAnotherStore',
    varName: 'USER_WANT_TO_SEARCH_ANOTHER_STORE',
    name: 'User - Wants to Search Another Store',
    shortName: 'Wants to Search Another Store',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_hasProvidedFeedback',
    varName: 'USER_HAS_PROVIDED_FEEDBACK',
    name: 'User - Has Provided Feedback',
    shortName: 'Has Provided Feedback',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_isUpdatingProfile',
    varName: 'USER_IS_UPDATING_PROFILE',
    name: 'User - Is Updating Profile',
    shortName: 'Is Updating Profile',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_selectedStoreFromSMS',
    varName: 'USER_SELECTED_STORE_FROM_SMS',
    name: 'User - Selected Store From SMS',
    shortName: 'Selected Store From SMS',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserTenantId',
    varName: 'USER_TENANT_ID',
    name: 'User - Tenant Id',
    shortName: 'Tenant Id',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserFMSError',
    varName: 'USER_FMS_ERROR',
    name: 'User - FMS Error',
    shortName: 'FMS Error',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserLeadStatus',
    varName: 'USER_LEAD_STATUS',
    name: 'User - FMS Lead Status',
    shortName: 'FMS Lead Status',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserEmailType',
    varName: 'USER_EMAIL_TYPE',
    name: 'User - Email Type',
    shortName: 'Email Type',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserEmailReceiptType',
    varName: 'USER_EMAIL_RECEIPT_TYPE',
    name: 'User - Email Receipt Type',
    shortName: 'Email Receipt Type',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAccessCode',
    varName: 'USER_ACCESS_CODE',
    name: 'User - Access Code',
    shortName: 'Access Code',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAccountStatus',
    varName: 'USER_ACCOUNT_STATUS',
    name: 'User - Account Status',
    shortName: 'Account Status',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAccountPaymentStatus',
    varName: 'USER_ACCOUNT_PAYMENT_STATUS',
    name: 'User - Account Payment Status',
    shortName: 'Account Payment Status',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserPaymentDueDate',
    varName: 'USER_PAYMENT_DUE_DATE',
    name: 'User - Payment Due Date',
    shortName: 'Payment Due Date',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserAutoPayEnabled',
    varName: 'USER_AUTO_PAY_ENABLED',
    name: 'User - Auto Pay Enabled',
    shortName: 'Auto Pay Enabled',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserDaysPastDue',
    varName: 'USER_DAYS_PAST_DUE',
    name: 'User - Days Past Due',
    shortName: 'Days Past Due',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserWantsToStoreVehicle',
    varName: 'USER_WANTS_TO_STORE_VEHICLE',
    name: 'User - Wants to Store Vehicle?',
    shortName: 'Wants to Store Vehicle?',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserWantToShopByPrice',
    varName: 'USER_WANT_TO_SHOP_BY_PRICE',
    name: 'User - Wants to Shop by Price?',
    shortName: 'Wants to Shop by Price?',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserFilterFeatures',
    varName: 'USER_FILTER_FEATURES',
    name: 'User - Filter Features',
    shortName: 'Filter Features',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserFilterSize',
    varName: 'USER_FILTER_SIZE',
    name: 'User - Filter Size',
    shortName: 'Filter Size',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserNotes',
    varName: 'USER_NOTES',
    name: 'User - Notes',
    shortName: 'Notes',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserUnitNumber',
    varName: 'USER_UNIT_NUMBER',
    name: 'User - Unit Number',
    shortName: 'Unit Number',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserUnitSize',
    varName: 'USER_UNIT_SIZE',
    name: 'User - Unit Size',
    shortName: 'Unit Size',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserUnitFeatures',
    varName: 'USER_UNIT_FEATURES',
    name: 'User - Unit Features',
    shortName: 'Unit Features',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'User_AccountBalance',
    varName: 'USER_ACCOUNT_BALANCE',
    name: 'User - Account Balance',
    shortName: 'Account Balance',
    description: '',
    scope: VariableScope.USER
  },
  {
    id: 'UserinAbandonedCartWorkflow',
    varName: 'USER_IN_ABANDONED_CART_WORKFLOW',
    name: 'User - In Abandoned Cart Workflow',
    shortName: 'In Abandoned Cart Workflow',
    description: 'The user is currently in the abandoned cart workflow.',
    scope: VariableScope.USER
  },
  {
    id: 'UserInterruptedProfileCollect',
    varName: 'USER_INTERRUPTED_PROFILE_COLLECT',
    name: 'User - Interrupted Profile Collect',
    shortName: 'Interrupted Profile Collect',
    description: 'The user sent a message while we were trying to collect their information.',
    scope: VariableScope.USER
  },
  {
    id: 'UserIsMobile',
    varName: 'USER_IS_MOBILE',
    name: 'User - Is Mobile',
    shortName: 'Is Mobile',
    description: 'The user is chating on a mobile device.',
    scope: VariableScope.USER
  },
  {
    id: 'UserReferredBy',
    varName: 'USER_REFERRED_BY',
    name: 'User - Referred by',
    shortName: 'Referred',
    description: 'The user ID of the referring tenant.',
    scope: VariableScope.USER
  },
  {
    id: 'UserReferredByName',
    varName: 'USER_REFERRED_BY_NAME',
    name: 'User - Referred by Name',
    shortName: 'Referred Name',
    description: 'The name of the referring tenant.',
    scope: VariableScope.USER
  },

  {
    id: UserVars.User_Sentiment,
    varName: UserVars.User_Sentiment,
    name: 'User - Sentiment',
    shortName: 'Sentiment',
    description: 'The sentiment of the score positive, negative etc.',
    scope: VariableScope.USER
  },
  {
    id: UserVars.User_SentimentScore,
    varName: UserVars.User_SentimentScore,
    name: 'User - Sentiment Score',
    shortName: 'Sentiment Score',
    description: 'The sentiment of the score  as a scalar.',
    scope: VariableScope.USER
  },

  {
    id: UserVars.User_IncomingCallNumber,
    varName: UserVars.User_IncomingCallNumber,
    name: 'User - Incoming Call Number',
    shortName: 'Incoming Call Number',
    description: 'The phone number of the incoming call',
    scope: VariableScope.USER
  },

  {
    id: 'StoreLocationNumber',
    varName: 'STORE_LOCATION_NUMBER',
    name: 'Store - Location Number',
    shortName: 'Store - Location Number',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreId',
    varName: 'STORE_ID',
    name: 'Store - FMS Facility Id',
    shortName: 'Store - FMS Facility Id',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreFMSIntegrationId',
    varName: 'STORE_FMS_INTEGRATION_ID',
    name: 'Store - FMS Integration Id',
    shortName: 'Store - FMS Integration Id',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreFMSType',
    varName: 'STORE_FMS_TYPE',
    name: 'Store - FMS Type',
    shortName: 'Store - FMS Type',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreName',
    varName: 'STORE_NAME',
    name: 'Store - Name',
    shortName: 'Store - Name',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreAddressLine1',
    varName: 'STORE_ADDRESS_LINE_1',
    name: 'Store - Address Line 1',
    shortName: 'Store - Address Line 1',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreCity',
    varName: 'STORE_CITY',
    name: 'Store - City',
    shortName: 'Store - City',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreState',
    varName: 'STORE_STATE',
    name: 'Store - State',
    shortName: 'Store - State',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePostalCode',
    varName: 'STORE_POSTAL_CODE',
    name: 'Store - Postal Code',
    shortName: 'Store - Postal Code',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePhoneNumber',
    varName: 'STORE_PHONE_NUMBER',
    name: 'Store - Phone Number',
    shortName: 'Store - Phone Number',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePayByPhoneNumber',
    varName: 'STORE_PAY_BY_PHONE_NUMBER',
    name: 'Store - Pay by Phone Number',
    shortName: 'Store - Pay by Phone Number',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreAfterHoursPhoneNumber',
    varName: 'STORE_AFTER_HOURS_PHONE_NUMBER',
    name: 'Store - After Hours Phone Number',
    shortName: 'Store - After Hours Phone Number',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreEmail',
    varName: 'STORE_EMAIL',
    name: 'Store - Email',
    shortName: 'Store - Email',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreDMName',
    varName: 'STORE_DM_NAME',
    name: 'Store - DM Name',
    shortName: 'Store - DM Name',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreDMEmail',
    varName: 'STORE_DM_EMAIL',
    name: 'Store - DM Email',
    shortName: 'Store - DM Email',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreWebsiteUrl',
    varName: 'STORE_WEBSITE_URL',
    name: 'Store - Location URL',
    shortName: 'Store - Location URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreUrlLookupPattern',
    varName: 'STORE_URL_LOOKUP_PATTERN',
    name: 'Store - URL Lookup Pattern',
    shortName: 'Store - URL Lookup Pattern',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePhotoURL',
    varName: 'STORE_PHOTO_URL',
    name: 'Store - Photo URL',
    shortName: 'Store - Photo URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreWalletPassURL',
    varName: 'STORE_WALLET_PASS_URL',
    name: 'Store - Wallet URL',
    shortName: 'Store - Wallet URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePaymentURL',
    varName: 'STORE_PAYMENT_URL',
    name: 'Store - Payment URL',
    shortName: 'Store - Payment URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreMapURL',
    varName: 'STORE_MAP_URL',
    name: 'Store - Map URL',
    shortName: 'Store - Map URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreOfficeHours',
    varName: 'STORE_OFFICE_HOURS',
    name: 'Store - Office Hours',
    shortName: 'Store - Office Hours',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreAccessHours',
    varName: 'STORE_ACCESS_HOURS',
    name: 'Store - Access Hours',
    shortName: 'Store - Access Hours',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreCallCenterHours',
    varName: 'STORE_CALL_CENTER_HOURS',
    name: 'Store - Call Center Hours',
    shortName: 'Store - Call Center Hours',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StorePaymentOptions',
    varName: 'STORE_PAYMENT_OPTIONS',
    name: 'Store - Payment Options',
    shortName: 'Store - Payment Options',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreRVStorage',
    varName: 'STORE_RV_STORAGE',
    name: 'Store - RV Storage',
    shortName: 'Store - RV Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreSmallVehicleStorage',
    varName: 'STORE_SMALL_VEHICLE_STORAGE',
    name: 'Store - Small Vehicle Storage',
    shortName: 'Store - Small Vehicle Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreTrailerStorage',
    varName: 'STORE_TRAILER_STORAGE',
    name: 'Store - Trailer Storage',
    shortName: 'Store - Trailer Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreDeliveriesAccepted',
    varName: 'STORE_DELIVERIES_ACCEPTED',
    name: 'Store - Deliveries Accepted',
    shortName: 'Store - Deliveries Accepted',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreVideoSurveillance',
    varName: 'STORE_VIDEO_SURVEILLANCE',
    name: 'Store - Video Surveillance',
    shortName: 'Store - Video Surveillance',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreSecurityAmenities',
    varName: 'STORE_SECURITY_AMENITIES',
    name: 'Store - Security Amenities',
    shortName: 'Store - Security Amenities',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreDriveUpUnits',
    varName: 'STORE_DRIVE_UP_UNITS',
    name: 'Store - Drive-Up Units',
    shortName: 'Store - Drive-Up Units',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreClimateControlledUnits',
    varName: 'STORE_CLIMATE_CONTROLLED_UNITS',
    name: 'Store - Climate Controlled Units',
    shortName: 'Store - Climate Controlled Units',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreHeatedUnits',
    varName: 'STORE_HEATED_UNITS',
    name: 'Store - Heated Units',
    shortName: 'Store - Heated Units',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreOfficeSpace',
    varName: 'STORE_OFFICE_SPACE',
    name: 'Store - Office Space',
    shortName: 'Store - Office Space',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreConferenceRoom',
    varName: 'STORE_CONFERENCE_ROOM',
    name: 'Store - Conference Room',
    shortName: 'Store - Conference Room',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreTruckRentals',
    varName: 'STORE_TRUCK_RENTALS',
    name: 'Store - Truck Rentals',
    shortName: 'Store - Truck Rentals',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreTwentyFourHourAccess',
    varName: 'STORE_TWENTY_FOUR_HOUR_ACCESS',
    name: 'Store - 24 Hour Access',
    shortName: 'Store - 24 Hour Access',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreLockersAvailable',
    varName: 'STORE_LOCKERS_AVAILABLE',
    name: 'Store - Lockers Available',
    shortName: 'Store - Lockers Available',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreLockTypes',
    varName: 'STORE_LOCK_TYPES',
    name: 'Store - Lock Type',
    shortName: 'Store - Lock Type',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreTruckTypes',
    varName: 'STORE_TRUCK_TYPES',
    name: 'Store - Truck Type',
    shortName: 'Store - Truck Type',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreParkingType',
    varName: 'STORE_PARKING_TYPE',
    name: 'Store - Parking Type',
    shortName: 'Store - Parking Type',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreLoadingAreaType',
    varName: 'STORE_LOADING_AREA_TYPE',
    name: 'Store - Loading Area Type',
    shortName: 'Store - Loading Area Type',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreLeadUnitId',
    varName: 'STORE_LEAD_UNIT_ID',
    name: 'Store - Lead Unit Id',
    shortName: 'Store - Lead Unit Id',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreAppointmentAvailable',
    varName: 'STORE_APPOINTMENT_AVAILABLE',
    name: 'Store - Appointment Available',
    shortName: 'Store - Appointment Available',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreGoogleReviewURL',
    varName: 'STORE_GOOGLE_REVIEW_URL',
    name: 'Store - Google Review URL',
    shortName: 'Store - Google Review URL',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreClimateControlDisplayName',
    varName: 'STORE_CLIMATE_CONTROL_DISPLAY_NAME',
    name: 'Store - Climate Control Display Name',
    shortName: 'Store - Climate Control Display Name',
    description: '',
    scope: VariableScope.LOCATION
  },

  {
    id: 'StoreInsuranceDisplayName',
    varName: 'STORE_INSURANCE_DISPLAY_NAME',
    name: 'Store - Insurance Display Name ',
    shortName: 'Store - Insurance Display Name ',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreHasElevator',
    varName: 'STORE_HAS_ELEVATOR',
    name: 'Store - Has Elevator',
    shortName: 'Store - Has Elevator',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreHasWineStorage',
    varName: 'STORE_HAS_WINE_STORAGE',
    name: 'Store - Has Wine Storage',
    shortName: 'Store - Has Wine Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreHasGunStorage',
    varName: 'STORE_HAS_GUN_STORAGE',
    name: 'Store - Has Gun Storage',
    shortName: 'Store - Has Gun Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreGooglePlaceId',
    varName: 'STORE_GOOGLE_PLACE_ID',
    name: 'Store - Google Place Id',
    shortName: 'Store - Google Place Id',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreGoogleAccountAndLocationName',
    varName: 'STORE_GOOGLE_ACCOUNT_AND_LOCATION_NAME',
    name: 'Store - Google Account and Location Name',
    shortName: 'Store - Google Account and Location Name',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreHasBoatStorage',
    varName: 'STORE_HAS_BOAT_STORAGE',
    name: 'Store - Has Boat Storage',
    shortName: 'Store - Has Boat Storage',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreBrandId',
    varName: 'STORE_BRAND_ID',
    name: 'Store - Brand Id',
    shortName: 'Store - Brand Id',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreCountryCode',
    varName: 'STORE_COUNTRY_CODE',
    name: 'Store - Country Code',
    shortName: 'Store - Country Code',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreOnlyShowUnitDimensions',
    varName: 'STORE_ONLY_SHOW_UNIT_DIMENSIONS',
    name: 'Store - Only Show Unit Dimensions',
    shortName: 'Store - Only Show Unit Dimensions',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreSpotLocationSlug',
    varName: 'STORE_SPOT_LOCATION_SLUG',
    name: 'Store - Spot Location Slug',
    shortName: 'Store - Spot Location Slug',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'StoreSpotLinkSlug',
    varName: 'STORE_SPOT_LINK_SLUG',
    name: 'Store - Spot Link Slug',
    shortName: 'Store - Spot Link Slug',
    description: '',
    scope: VariableScope.LOCATION
  },
  {
    id: 'SpaceId',
    varName: 'SPACE_ID',
    name: 'Space - Id',
    shortName: 'Id',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceName',
    varName: 'SPACE_NAME',
    name: 'Space - Name',
    shortName: 'Name',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceDimensions',
    varName: 'SPACE_DIMENSIONS',
    name: 'Space - Dimensions',
    shortName: 'Dimensions',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceRate',
    varName: 'SPACE_RATE',
    name: 'Space - Rate',
    shortName: 'Rate',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceHasClimateControl',
    varName: 'SPACE_HAS_CLIMATE_CONTROL',
    name: 'Space - Climate Controlled',
    shortName: 'Climate Controlled',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceIsInside',
    varName: 'SPACE_IS_INSIDE',
    name: 'Space - Indoor',
    shortName: 'Indoor',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceIsUpperStack',
    varName: 'SPACE_IS_UPPER_STACK',
    name: 'Space - Upper Stack',
    shortName: 'Upper Stack',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceIsLowerStack',
    varName: 'SPACE_IS_LOWER_STACK',
    name: 'Space - Lower Stack',
    shortName: 'Lower Stack',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceHasPower',
    varName: 'SPACE_HAS_POWER',
    name: 'Space - Has Power',
    shortName: 'Has Power',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceFloor',
    varName: 'SPACE_FLOOR',
    name: 'Space - Floor #',
    shortName: 'Floor #',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceIsParking',
    varName: 'SPACE_IS_PARKING',
    name: 'Space - Is Parking',
    shortName: 'Is Parking',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceIsDriveUp',
    varName: 'SPACE_IS_DRIVE_UP',
    name: 'Space - Drive Up',
    shortName: 'Drive Up',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceHasElevatorAccess',
    varName: 'SPACE_HAS_ELEVATOR_ACCESS',
    name: 'Space - Has Elevator Access',
    shortName: 'Has Elevator Access',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceHasAlarm',
    varName: 'SPACE_HAS_ALARM',
    name: 'Space - Has Alarm',
    shortName: 'Has Alarm',
    description: '',
    scope: VariableScope.SPACE
  },
  {
    id: 'SpaceFeatures',
    varName: 'SPACE_FEATURES',
    name: 'Space - Features',
    shortName: 'Features',
    description: '',
    scope: VariableScope.SPACE
  }
]
